import { UpdateSecondHandCompanyInputType } from "~/types/data/SecondHandCompany.type";

export const validateUpdateSecondHandCompany = (
  input: UpdateSecondHandCompanyInputType
) => {
  if (!input.name) return "Name can't be empty.";

  if (!input.id) return "Id can't be empty.";
};
